export enum EAppService {
  AppStore = 'AppStore',
  GooglePlay = 'GooglePlay',
  RuStore = 'RuStore',
  AppGallery = 'AppGallery',
}

export const appItems = [
  {
    name: EAppService.GooglePlay,
    className: 'google-btn',
  },
  {
    name: EAppService.AppStore,
    className: 'apple-btn',
  },
  {
    name: EAppService.RuStore,
    className: 'ru-store-btn',
  },
  {
    name: EAppService.AppGallery,
    className: 'huawei-btn',
  },
];
